import { render, staticRenderFns } from "./FormNav.vue?vue&type=template&id=5fc11947&scoped=true"
import script from "./FormNav.vue?vue&type=script&lang=js"
export * from "./FormNav.vue?vue&type=script&lang=js"
import style0 from "./FormNav.vue?vue&type=style&index=0&id=5fc11947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc11947",
  null
  
)

export default component.exports